import { render, staticRenderFns } from "./Toaster.vue?vue&type=template&id=2048fcb6&scoped=true"
import script from "./Toaster.vue?vue&type=script&lang=js"
export * from "./Toaster.vue?vue&type=script&lang=js"
import style0 from "./Toaster.vue?vue&type=style&index=0&id=2048fcb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2048fcb6",
  null
  
)

export default component.exports